import axios from "axios";
import Cookies from "js-cookie";
import { ID, Participant } from "models";

export const editParticipant = ({ id, participant }: { id: ID; participant: Participant }) => {
  return axios
    .put(`/api/v1/participant/${id}/`, participant, {
      headers: {
        "X-CSRFToken": Cookies.get("csrftoken"),
        "Content-Type": "application/json;charset=utf-8"
      }
    })
    .then((res) => {
      return res;
    });
};
